export default __webpack_public_path__ + "static/media/passenger_first.a0ca9a51.png";